import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDelete = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.1667 3.99935H17.3334V5.66602H15.6667V16.4993C15.6667 16.9596 15.2937 17.3327 14.8334 17.3327H3.16675C2.70651 17.3327 2.33341 16.9596 2.33341 16.4993V5.66602H0.666748V3.99935H4.83341V1.49935C4.83341 1.03912 5.20651 0.666016 5.66675 0.666016H12.3334C12.7937 0.666016 13.1667 1.03912 13.1667 1.49935V3.99935ZM14.0001 5.66602H4.00008V15.666H14.0001V5.66602ZM6.50008 8.16602H8.16675V13.166H6.50008V8.16602ZM9.83341 8.16602H11.5001V13.166H9.83341V8.16602ZM6.50008 2.33268V3.99935H11.5001V2.33268H6.50008Z",
		fill: "currentColor"
	})
});
export default SvgDelete;
